import { Box, SwipeableDrawer } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setFlyoutOpen } from '../../store/slices/menuSlice';
import FlyoutMenuList from './FlyoutMenuList';

const FlyoutMenu = () => {
  const flyoutOpen = useAppSelector((state) => state.menu.flyoutOpen);
  const dispatch = useAppDispatch();

  const toggleDrawer = (newOpen: boolean) => () => {
    dispatch(setFlyoutOpen(newOpen));
  };

  return (
    <SwipeableDrawer anchor="right" open={flyoutOpen} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      <Box
        sx={{
          height: '100%',
          overflow: 'auto',
          m: 2,
        }}>
        <FlyoutMenuList />
      </Box>
    </SwipeableDrawer>
  );
};
export default FlyoutMenu;
